<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg"
            :doctorId="doctorId"></DocMsg>
    <div class="page_title">
      患者问诊单列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="box">
          <div class="searchbox">
            <span>医生姓名</span>
            <el-input v-model="searchForm.doctor_name"
                      placeholder="请输入"
                      style="width: 160px; margin: 0 10px 0 5px"
                      @input="search"
                      clearable>
            </el-input>
            <span>医生手机</span>
            <el-input v-model="searchForm.doctor_phone"
                      placeholder="请输入"
                      style="width: 160px; margin: 0 10px 0 5px"
                      @input="search"
                      clearable></el-input>
            <span>患者姓名</span>
            <el-input v-model="searchForm.user_name"
                      placeholder="请输入"
                      style="width: 160px; margin: 0 10px 0 5px"
                      @input="search"
                      clearable>
            </el-input>
            <span>患者手机</span>
            <el-input v-model="searchForm.phone"
                      placeholder="请输入"
                      style="width: 160px; margin: 0 10px 0 5px"
                      @input="search"
                      clearable>
            </el-input>
            <el-button type="info"
                       style="background-color: #eceff2; color: #747981"
                       @click="search">查询
            </el-button>
            <el-button plain
                       @click="search">重置</el-button>
          </div>

          <div style="border: solid 1px #c9cbd6">
            <el-table v-loading="tableLoading"
                      ref="multipleTable"
                      :data="tableData"
                      tooltip-effect="dark"
                      style="width: 100%; min-width: 1000px"
                      :header-cell-style="{ background: '#F5F5F5' }">

              <el-table-column v-for="(item,index) in tableHeader"
                               :key="index"
                               :label="item.label"
                               :prop="item.prop"
                               :width="item.width"
                               :align="item.align">
                <template slot-scope="scope">
                  <div v-if="item.prop == 'sex'">
                    {{ scope.row.sex | sexFilter }}
                  </div>
                  <div v-if="item.prop == 'doctor_name'"
                       @click="showDocMsg(scope.row.doctor_id)"
                       style="cursor:pointer">
                    {{ scope.row.doctor_name}}
                  </div>
                  <div v-else>{{ scope.row[item.prop] }}</div>
                </template>
              </el-table-column>

              <el-table-column label="问诊单数量"
                               prop="inquiry_count"
                               align="center">
                <template slot-scope="scope">
                  <el-link type="primary"
                           :disabled=" module_id_array[0] ? !module_id_array.includes('745') : false"
                           @click="toVisitsDetails(scope.row)">{{ scope.row.inquiry_count }}</el-link>
                </template>
              </el-table-column>

              <el-table-column label="病历数量"
                               prop="success_count"
                               align="center">
                <template slot-scope="scope">
                  <el-link type="primary"
                           :disabled=" module_id_array[0] ? !module_id_array.includes('745') : false"
                           @click="toRrecords(scope.row)">{{ scope.row.success_count }}</el-link>
                </template>
              </el-table-column>

              <el-table-column label="操作"
                               width="220">
                <template slot-scope="scope">
                  <el-button v-if="!scope.row.notice_id"
                             type="text"
                             @click="noFollowUp(scope.row)"
                             :disabled="module_id_array[0]? !module_id_array.includes('634'): false">未设随访</el-button>
                  <el-button v-else
                             type="text"
                             @click="yesFollowUp(scope.row)"
                             :disabled="module_id_array[0]? !module_id_array.includes('634'): false">已设随访</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <pagination v-show="totalNum>0"
                        :total="totalNum"
                        :page.sync="pagination.page"
                        :limit.sync="pagination.pageNumber"
                        @pagination="getList" />
          </div>
        </div>
      </div>
    </div>
    <!-- 未设置随访 -->
    <el-dialog title="当前未设置随访"
               :visible.sync="noFollowUpDia"
               width="600px"
               :close-on-click-modal="false">
      <div class="followUpDialog">
        <div class="title">
          <p>患者: {{ followInfo.user_name }}</p>
          <p>医生: {{ followInfo.doctor_name }}</p>
        </div>
        <div class="content">
          <div class="quick-choose">
            <el-radio v-model="noFollowradio"
                      :label="2">快捷选择</el-radio>
            <el-select v-model="noFollowTime"
                       :disabled="noFollowradio == 1"
                       clearable
                       size="small"
                       placeholder="请选择">
              <el-option v-for="item in options"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <p class="time">{{ followInfo.notice_time }}</p>
          </div>

          <div class="calendar-select">
            <el-radio v-model="noFollowradio"
                      :label="1">日历选择</el-radio>
            <el-calendar v-show="noFollowradio == 1"
                         v-model="noFollowdate">
            </el-calendar>
          </div>
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer"
              class="dialog-footer">
          <el-button plain
                     @click="noFollowUpDia = false"
                     size="medium">关闭</el-button>
          <el-button type="primary"
                     @click="confirmNoFollowUp"
                     size="medium">确定
          </el-button>
        </span>
      </div>
    </el-dialog>

    <!-- 已设置随访 -->
    <el-dialog title="当前已设置随访"
               :visible.sync="yesFollowUpDia"
               width="400px"
               :close-on-click-modal="false">
      <div class="followUpDialog-info">
        <div class="title">
          <p>患者: {{ followInfo.user_name }}</p>
          <p>医生: {{ followInfo.doctor_name }}</p>
        </div>
        <div class="title">
          <p>{{ followInfo.notice_time }}</p>
          <p>随访提醒</p>
        </div>
      </div>
      <div style="text-align: center; padding-bottom: 20px">
        <span slot="footer"
              class="dialog-footer">
          <el-button plain
                     @click="yesFollowUpDia = false"
                     size="medium">关闭</el-button>
          <el-button type="primary"
                     @click="editorFollowUp"
                     size="medium">修改
          </el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '../../../components/Pagination/index';
import dayjs from 'dayjs';
import message from '../../../api/message';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  components: {
    Pagination,
    DocMsg
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      tableHeader: [
        {
          label: '患者姓名',
          prop: 'user_name',
          width: 'auto',
          align: 'center'
        },
        {
          label: '性别',
          prop: 'sex',
          width: 'auto',
          align: 'center'
        },
        {
          label: '年龄',
          prop: 'age',
          width: 'auto',
          align: 'center'
        },
        {
          label: '手机号',
          prop: 'phone',
          width: 'auto',
          align: 'center'
        },
        {
          label: '医生姓名',
          prop: 'doctor_name',
          width: 'auto',
          align: 'center'
        },
        {
          label: '手机号',
          prop: 'doctor_phone',
          width: 'auto',
          align: 'center'
        }
      ],
      tableData: [],
      searchForm: {
        doctor_name: '',
        doctor_phone: '',
        phone: '',
        user_name: ''
      },
      pushList: [],
      business_id: '',
      doctor_id: '',
      patient_id: '',
      noFollowUpDia: false,
      followInfo: {},
      noFollowradio: 2,
      noFollowTime: '15天后',
      noFollowdate: '',
      options: [
        {
          label: '15天后',
          value: '15天后'
        },
        {
          label: '30天后',
          value: '30天后'
        },
        {
          label: '60天后',
          value: '60天后'
        },
        {
          label: '90天后',
          value: '90天后'
        },
        {
          label: '180天后',
          value: '180天后'
        },
        {
          label: '一年后',
          value: '一年后'
        }
      ],
      yesFollowUpDia: false,
      doc_msg: false,
      doctorId: ''
    };
  },
  filters: {
    sexFilter(val) {
      switch (val) {
        case 0:
          return '未知';
        case 1:
          return '男';
        case 2:
          return '女';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      this.tableLoading = true;
      let params = Object.assign(this.searchForm, this.pagination);

      message.getInquiryPatientList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.tableData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },

    // 问诊单数量
    toVisitsDetails(row) {
      this.$router.push({
        path: '/home/message/inquiryNum',
        query: {
          doctor_id: row.doctor_id,
          patient_id: row.patient_id,
          type: 1
        }
      });
    },
    // 病历数量
    toRrecords(row) {
      this.$router.push({
        path: '/home/message/patientRecords',
        query: {
          doctor_id: row.doctor_id,
          patient_id: row.patient_id,
          type: 2
        }
      });
    },
    // 未设置随访
    noFollowUp(row) {
      this.noFollowradio = 2;
      row.notice_time = dayjs(this.followInfo.notice_time).format('YYYY-MM-DD');
      this.followInfo = row;
      this.noFollowUpDia = true;
    },
    yesFollowUp(row) {
      this.noFollowradio = row.type;
      if (row.type == 1) {
        this.noFollowdate = row.timestamp;
      } else {
        this.noFollowTime = row.timestamp;
      }
      row.notice_time = dayjs(this.followInfo.notice_time).format('YYYY-MM-DD');
      this.followInfo = row;
      console.log(row);
      this.yesFollowUpDia = true;
    },
    // 修改
    editorFollowUp() {
      console.log(this.noFollowradio);
      this.yesFollowUpDia = false;
      this.noFollowUpDia = true;
    },
    // 确认未设置随访
    confirmNoFollowUp() {
      if (this.noFollowradio == 1) {
        let date1 = dayjs(this.noFollowdate).format('YYYY-MM-DD');
        date1 = new Date(date1);
        let date2 = new Date();
        if (this.noFollowdate == '' || date1.getTime() <= date2.getTime()) {
          this.$message.warning('日期必须大于当前日期');
          return;
        }
      }
      let params = {
        doctor_id: this.followInfo.doctor_id,
        user_id: this.followInfo.user_id,
        patient_id: this.followInfo.patient_id,
        type: this.noFollowradio,
        timestamp:
          this.noFollowradio == 2
            ? this.noFollowTime
            : dayjs(this.noFollowdate).format('YYYY-MM-DD')
      };
      message.subBusinessNotice(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('设置成功');
          this.getList();
          this.noFollowUpDia = false;
        }
      });
    }
  },
  created() {
    this.getList();
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
.dialog {
  padding: 20px;
  text-align: left;
}
.followUpDialog {
  padding: 10px;
  .title {
    height: 20px;
    font-size: 15px;
    display: flex;
    align-items: center;
    p {
      padding-right: 20px;
    }
  }
  .content {
    .quick-choose {
      padding: 10px 0;
      display: flex;
      align-items: center;
      .time {
        padding-left: 10px;
      }
    }
    .calendar-select {
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .el-calendar {
        ::v-deep .el-calendar-table .el-calendar-day {
          height: 30px;
        }
        ::v-deep .el-calendar__header {
          .el-button-group > .el-button:first-child {
            display: none;
          }
        }
      }
    }
  }
}
.followUpDialog-info {
  padding: 10px;
  .title {
    height: 40px;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      padding-right: 40px;
    }
  }
}
</style>
<style>
.dialog .el-radio-group {
  display: flex;
  flex-direction: column;
  height: 300px;
  overflow-y: scroll;
}
</style>
